import { API_BASE } from '../config';
import { wouldExceedStorageQuota } from './storage-quota';

export async function uploadNoteFileAsProjectResource(
  token: string,
  projectId: string,
  attachment: File
): Promise<string> {
  const exceedsQuota = await wouldExceedStorageQuota(token, attachment.size);
  if (exceedsQuota) {
    window.dispatchEvent(new CustomEvent('storage-limit-reached'));
    throw new Error('STORAGE_LIMIT_REACHED');
  }

  const presignedRes = await fetch(`${API_BASE}/api/projects/${projectId}/resources/presigned-url`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      fileName: attachment.name,
      fileSize: attachment.size,
      mimeType: attachment.type || 'application/octet-stream',
    }),
  });
  if (!presignedRes.ok) {
    const err = await presignedRes.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to get upload URL');
  }
  const { presignedUrl, s3Key } = await presignedRes.json();
  const uploadRes = await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': attachment.type || 'application/octet-stream' },
    body: attachment,
  });
  if (!uploadRes.ok) {
    throw new Error('Upload failed');
  }
  const saveRes = await fetch(`${API_BASE}/api/projects/${projectId}/resources`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      fileName: attachment.name,
      fileSize: attachment.size,
      mimeType: attachment.type || 'application/octet-stream',
      s3Key,
      fromNote: true,
    }),
  });
  if (!saveRes.ok) {
    const err = await saveRes.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to save resource');
  }
  const saveData = await saveRes.json();
  return saveData.id as string;
}
